export const experienceData = [
  {
    company: "OCBC",
    title: "Assistant Vice President",
    location: "Greater Kuala Lumpur",
    period: "Nov 2024 - Present",
    highlights: [
      "Microservices Architecture: Developed and maintained scalable microservices using Java 21 and Spring Boot, enhancing system modularity and performance.",
      "Batch Processing: Utilized Spring Batch with PostgreSQL to streamline batch job processes, achieving a 30% reduction in processing time.",
      "API Development: Designed RESTful APIs to ensure seamless integration between services and external clients.",
      "Performance Optimization: Monitored application performance, implementing enhancements that reduced latency and increased throughput."
    ]
  },
  {
    company: "Etiqa Insurance and Takaful",
    title: "Java Developer",
    location: "Bangsar, Kuala Lumpur",
    period: "Jul 2024 - Nov 2024",
    highlights: [
      "Modernizing and Optimizing Legacy Systems: Implemented a microservice architecture to modernize and optimize legacy systems.",
      "Core Life System Development: Developed microservices for the Core Life System, focusing on policy servicing modules.",
      "Legacy Code Management: Managed and deployed legacy code using WebLogic, ensuring continued functionality while transitioning to modern systems."
    ]
  },
  {
    company: "Nippon Paint Malaysia",
    title: "Senior Full-stack Developer",
    location: "Shah Alam, Selangor",
    period: "Aug 2023 - Jul 2024",
    highlights: [
      "Designed and implemented responsive, user-friendly front-end interfaces using modern web technologies.",
      "Developed and maintained robust back-end systems, ensuring scalability, security, and high performance.",
      "Collaborated with cross-functional teams to translate project requirements into technical solutions."
    ]
  },
  {
    company: "TIME dotCom Berhad",
    title: "Software Developer",
    location: "Shah Alam, Selangor",
    period: "Sep 2018 - Aug 2023",
    highlights: [
      "Revised, modularized and updated old code bases to modern development standards, reducing operating costs.",
      "Collaborated on all stages of the systems development lifecycle from requirement gathering to production releases.",
      "Designed customized solutions for proposals to potential customers and tuned systems to boost performance."
    ]
  },
  {
    company: "HeiTech Padu Berhad",
    title: "Junior System Engineer",
    location: "Selangor, Malaysia",
    period: "Sep 2016 - Aug 2017",
    highlights: [
      "Streamlined troubleshooting processes to improve system support and enhance communication with end-users.",
      "Integrated database and backup servers into enterprise systems and configured SQL databases.",
      "Proposed technical feasibility solutions for new system designs and performance improvements."
    ]
  }
];
